import isDateInPast from './isDateInPast'

export const tsaPrecheckPromotionalPrice = Number(0.0).toFixed(2)

export const tsaPrecheckClearBundlePrice = 209

/** 07-01-2026 */
const UPDATED_BUNDLE_PRICE = 219
const PENDING_CONFIG = 'loading...'

export const formatPrice = (price: number, decimals: 0 | 1 | 2 = 0) =>
  `$${price.toFixed(decimals)}`

/** total amount of TPC & C+ bundled together */
export const getClearPlusBundlePricing = ({
  clearPlusPricingUpdate,
  precheckPricing,
}: Partial<{
  clearPlusPricingUpdate: boolean
  precheckPricing: Partial<{
    enroll: number
    renewal: number
  }>
}>) => {
  const bundlePrice = clearPlusPricingUpdate
    ? UPDATED_BUNDLE_PRICE
    : tsaPrecheckClearBundlePrice

  const enrollmentPortion =
    typeof precheckPricing?.enroll === 'number'
      ? formatPrice(bundlePrice - precheckPricing.enroll)
      : PENDING_CONFIG
  const combinedEnroll =
    typeof precheckPricing?.enroll === 'number'
      ? formatPrice(precheckPricing.enroll + bundlePrice, 2)
      : PENDING_CONFIG

  const renewalPortion =
    typeof precheckPricing?.renewal === 'number'
      ? formatPrice(bundlePrice - precheckPricing.renewal)
      : PENDING_CONFIG
  const combinedRenewal =
    typeof precheckPricing?.renewal === 'number'
      ? formatPrice(precheckPricing.renewal + bundlePrice, 2)
      : PENDING_CONFIG

  return {
    price: {
      raw: bundlePrice,
      formatted: {
        value: formatPrice(bundlePrice),
        diff: {
          enrollmentPortion,
          renewalPortion,
        },
        combined: {
          enroll: combinedEnroll,
          renewal: combinedRenewal,
        },
      },
    },
  }
}

export const isFamDiscountExpired = isDateInPast('2025-12-31')
